module.exports = __webpack_public_path__ + "static/media/apilar.6a8a9321.svg";